import React, { createContext, useContext, useState, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const location = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const stored = localStorage.getItem('tapInDarkMode');
    return stored === 'true';
  });

  // Only apply dark class on /app/* routes — public pages stay light
  const isAppRoute = location.pathname.startsWith('/app') || location.pathname.startsWith('/onboarding');

  useLayoutEffect(() => {
    if (isDarkMode && isAppRoute) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode, isAppRoute]);

  // Persist preference
  useLayoutEffect(() => {
    localStorage.setItem('tapInDarkMode', String(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(prev => !prev);
  const setDarkMode = (val) => setIsDarkMode(Boolean(val));

  const value = {
    isDarkMode: isDarkMode && isAppRoute,
    toggleDarkMode,
    setDarkMode,
    isThemeReady: true,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeContext;
